<template>
  <v-dialog
      v-model="dialog"
      v-bind:disabled="!hasCategory"
      persistent
      max-height="680"
      scrollable
      :fullscreen="$vuetify.display.xs"
      :width="$vuetify.display.smAndUp ? 600 : 'auto'"
      style="z-index: 1100 !important;"
    >

    <template v-slot:activator="{ props }">
      <div v-bind="props" data-cy="tenantLabels-deleteCategory-activator">
        <slot></slot>
      </div>
    </template>

    <div class="vb-dialog vb-dialog-danger">
      <v-card v-cloak data-cy="dialog-deleteCategory-modal">
        <v-card-title class="d-flex justify-space-between mb-2">
          {{$t('routes.labels.deleteCategory')}}

          <v-btn icon @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <p class="mt-4">
            {{$t('routes.labels.confirmDeleteCategory')}}
          </p>

          <p class="font-weight-bold mt-4">
            {{ category.name }}
          </p>
        </v-card-text>

        <v-card-actions>
          <v-btn class="ml-auto bg-red-darken-3" color="btnOk" elevation=0 @click="deleteCategory" data-cy="dialog-deleteCategory-ok">
            {{$t('common.delete')}}
          </v-btn>
          <v-btn variant="text" @click="dialog = false" class="btnCancel" data-cy="dialog-deleteCategory-false">
            {{$t('common.cancel')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </div>
  </v-dialog>
</template>

<script>
import { useAuthStore } from '@/stores/AuthStore.js'
import { useLabelStore } from '@/stores/LabelStore.js'
import DialogActionKeys from '@/components/mixin/DialogActionKeys.js';

export default {
  emits: ["categoryDeleted"],
  mixins: [DialogActionKeys],
  name: "DeleteCategoryDialog",

  props: {
    category: {
      type: Object,
      required: true,
    }
  },

  data: function() {
    return {
      dialog: false,
    }
  },

  methods: {
    deleteCategory: function() {
      const payload = {
        categoryId: this.category.id,
        accessPointId: this.accessPointId,
      };

      const labelStore = useLabelStore();
      labelStore.deleteCategory(payload)
        .then(() => {
          this.$emit('categoryDeleted', { categoryId: this.category.id });

          this.dialog = false;
        })
        .catch((error) => {
          const apiError = error?.response?.data?.error?.message;

          if (apiError) {
            this.$showMessage(apiError, { type: 'error' });
          } else {
            console.log(apiError);
          }
        });
    },
  },

  computed: {
    accessPointId() {
      const authStore = useAuthStore();
      return authStore.rootNodeId;
    },
    hasCategory() {
      return !!(this.category && this.category.id);
    }
  }
};
</script>

<style>

</style>
